import { useParams, useNavigate } from "react-router-dom";
import { useUtils } from '../utils/utils';
import { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import { selectRider } from '../features/selectedRiderSlice';
import {APIProvider, Map} from '@vis.gl/react-google-maps';

import { db } from '../firebase'
import { query, getDocs, collection, where, orderBy, doc, getDoc } from 'firebase/firestore';

import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';

import TourMap from "./TourMap";
import MapView from "./MapView";
import DailyHeader from "./DailyHeader";
import ImageWithTextOverlay from "./ImageWithTextOverlay";
import MomentsGallery from "./MomentsGallery";

const TourDetails = () => {
  const position = {lat: 12.9716, lng: 77.5946}; //Bangalore
  const tourId = useParams().tourId;
  const navigate = useNavigate();
  const selectedRider = useSelector(selectRider);
  const [rides, setRides] = useState([]);
  const [moments, setMoments] = useState([]);
  const [momentsMessage, setMomentsMessage] = useState('Loading moments...');
  const [tour, setTour] = useState(null);
  const [loading, setLoading] = useState(false);

  //For day map
  const [rideIds, setRideIds] = useState([])
  const [selectedRide, setSelectedRide] = useState(null)
  const [selectedRideId, setSelectedRideId] = useState(null)
  const [routeCoordinates, setRouteCoordinates] = useState([])
  const [dayMoments, setDayMoments] = useState([])
  const [selectedMoment, setSelectedMoment] = useState(null)

  const {formatTextDate} = useUtils();
  
  // console.log('In TourDetails ', tourId, selectedRider?.uid)   
  
  useEffect(() => {
    //get tour
    
    if (!selectedRider || !tourId) {
      return;
    }

    const fetchRidesAndMoments = async () => {
      setLoading(true);
      try {
        const tourDocRef = doc(db, `/users/${selectedRider.uid}/tours/${tourId}`);
        const tourDoc = await getDoc(tourDocRef);
        if (!tourDoc.exists()) {
          return;
        }

        setTour({id: tourDoc.id, ...tourDoc.data()});

        //Get Rides & Locations
        const ridesRef = collection(db, `/users/${selectedRider.uid}/rides`);
        //using __name__ to filter by document id
        const ridesQuery = query(ridesRef, where('__name__', 'in', tourDoc.data().dates));
        const rideDocs = await getDocs(ridesQuery);
        let tourRides = [];
        rideDocs.forEach(rideDoc => {
          tourRides = [...tourRides, {...rideDoc.data(), id: rideDoc.id}];
        })
        
        setRides(tourRides);
        setRideIds(tourDoc.data().dates)

        //get tour moments
        const momentsRef = collection(db, `/users/${selectedRider.uid}/moments`);
        const momentsQuery = query(momentsRef, where('date', 'in', tourDoc.data().dates), orderBy('photoTime'));
        const momentDocs = await getDocs(momentsQuery);
        let tourMoments = [];
        momentDocs.forEach(momentDoc => {
          tourMoments = [...tourMoments, {...momentDoc.data(), id: momentDoc.id}]
        })
        setMoments(tourMoments);  
        if (tourMoments.length === 0) {
          setMomentsMessage('No pictures for the day')
        }

        //set selected date, ride coordinates, dayMoments, and selectedMoment
        if (tourRides.length > 0) {
          // handleSelectRide(tourRides[0].id)
          const rideId = tourRides[0].id;
          setSelectedRideId(rideId);
          setSelectedRide(tourRides[0]);
          const rideDayLocations = tourRides.find(ride => ride.id === rideId)?.locations || [];
          setRouteCoordinates(rideDayLocations.map(locn => {
                                return {lat: locn.latitude, lng: locn.longitude}
                              }))
          const tempMoments = tourMoments.filter(moment => moment.date === rideId);
          setDayMoments(tempMoments);
          if (tempMoments.length > 0) {
            setSelectedMoment(tempMoments[0]);
          } else {
            setSelectedMoment(null);
          }
        }
      } catch(err) {
        console.error('Error in fetchRidesAndMoments', err);
      } finally {
        setLoading(false);
      }
    }
    
    fetchRidesAndMoments();

  }, [tourId, selectedRider])

  const handleSelectRide = (rideId) => {
    setSelectedRideId(rideId);
    const tempSelectedRide = rides.find(ride => ride.id === rideId);
    setSelectedRide(tempSelectedRide);
    const rideDayLocations = tempSelectedRide?.locations || [];
    setRouteCoordinates(rideDayLocations.map(locn => {
                          return {lat: locn.latitude, lng: locn.longitude}
                        }))
    const tempMoments = moments.filter(moment => moment.date === rideId);
    setDayMoments(tempMoments);
    if (tempMoments.length > 0) {
      setSelectedMoment(tempMoments[0]);
    } else {
      setSelectedMoment(null);
    }
  }
  const handleSelectMoment = (moment) => {
    setSelectedMoment(moment);
  }

  if (!tour) {
    return null;
  }

  let mediaContent = '';  
  if (tour.media) {
    mediaContent = tour.media.map((mi, idx) => {
      return <Card.Link href={mi.link} target="_blank" key={`${tour.id}-${idx}`}>{mi.type}</Card.Link>
    });
  }
  //MARK: Main View
  return(
    <Container>
      <Card>
        <Card.Body>
          <div className="card-title d-flex justify-content-between mb-3">
            <h4>{tour.tourTitle}</h4>
            <Button as="a" variant='link' onClick={() => navigate('/tours')}>Back to all Tours</Button>
          </div>
          {/* <Card.Title className="mb-3">{tour.tourTitle}</Card.Title> */}
          <Card.Subtitle className="mb-2">{formatTextDate(tour.dates[0])} to {formatTextDate(tour.dates[tour.dates.length - 1])}</Card.Subtitle>
          {mediaContent}
          <Card.Text className="my-2">{tour.description}</Card.Text>
          
          <Tabs defaultActiveKey="photos">
            <Tab eventKey="photos" title="Photos">
              <Row xs={1} md={2} lg={4} className="g-4 pt-1">
                { moments.map(moment => {
                    return (
                      <Col key={moment.id}>
                        <Card>
                          <ImageWithTextOverlay 
                            moment={moment}
                          />
                          <Card.Subtitle>{moment.title}</Card.Subtitle>
                          <Card.Text>{moment.description}</Card.Text>
                        </Card>
                        
                          {/* Add title here later */}
                      </Col>
                    )
                  })
                }
                {moments.length === 0 && <div>{momentsMessage}</div>}
              </Row>
            </Tab>
            <Tab eventKey="routeMap" title="Route Map">
              <div style={{height: '75vh'}}>
                <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
                  <TourMap rides={rides} />
                  <Map scaleControl={true} mapId={process.env.REACT_APP_MAP_ID} center={position} zoom={16} >
                  </Map>
                </APIProvider>
              </div>
            </Tab>
            <Tab eventKey="dayDetails" title="Daily Details">
              {loading ? (
                <div className="d-flex justify-content-center align-items-center h-100">
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                </div>
              ) : (
                <div>
                  <Row className="mb-2">
                    <Col>
                      <DailyHeader
                        rideIds={rideIds}
                        selectedRideId={selectedRideId}
                        selectedRide={selectedRide}
                        onSelectRide={handleSelectRide}
                      />
                    </Col>
                  </Row>
                
                  <Row className="flex-grow-1">
                    <Col md={6} className="d-flex flex-column mb-3 mb-md-0" style={{ minHeight: '500px' }}>
                      <MapView 
                        routeCoordinates={routeCoordinates}
                        rideId={selectedRideId}
                        moments={dayMoments}
                        selectedMoment={selectedMoment}
                        onSelectMoment={handleSelectMoment}
                      />
                    </Col>
                    <Col md={6} className="d-flex flex-column" style={{ minHeight: '500px' }}>
                      <MomentsGallery 
                        moments={dayMoments}
                        selectedMoment={selectedMoment}
                        onSelectMoment={handleSelectMoment}
                      />
                    </Col>
                  </Row>
                </div>
              )}
            </Tab>
          </Tabs>
        </Card.Body>
      </Card>
    </Container>
  ) 
}

export default TourDetails;